<table class="table is-fullwidth" aria-describedby="log">
  <tbody>
    <tr class="weight-medium">
      <th class="weight-medium" id="operation">{{ 'operation-log.operation' | translate }}</th>
      <th class="weight-medium" id="operation">{{ 'operation-log.state' | translate }}</th>
      <th class="weight-medium" id="date">{{ 'operation-log.date' | translate }}</th>
      <th class="weight-medium" id="time">{{ 'operation-log.time' | translate }}</th>
      <th class="weight-medium" id="user">{{ 'operation-log.user' | translate }}</th>
      <th id="void"></th>
    </tr>
    <tr *ngFor="let operation of operations">
      <td>
        {{ 'operation-log.' + operation.result?.operationType | translate }}
      </td>
      <td>{{ 'operation-log.' + operation.result?.status | translate }}</td>
      <td>{{ operation.date | customDate | date | localizedDate : 'dd MMM y ' : '+0000' }}</td>
      <td>{{ operation.date | date : 'HH:mm' }}</td>
      <td>{{ operation.user?.name }}</td>
      <td class="is-uppercase has-text-link weight-medium" (click)="openContent.emit(operation)">
        <a
          *ngIf="operation.result?.confirmations?.length > 0 || operation.result?.cancellationQuote"
          >{{ 'operation-log.show' | translate }}
        </a>
      </td>
    </tr>
    <br />
    <br />
  </tbody>
</table>
